<template>
  <v-card>
    <v-tabs :grow="$vuetify.breakpoint.smAndDown" v-model="active">
      <v-tab v-for="tab in tabs" :key="tab.to">
        <router-link :to="{name: tab.to}" class="tab-link">{{ tab.title }}</router-link>
      </v-tab>
    </v-tabs>
    <transition name="fade-transition" mode="out-in">
      <router-view></router-view>
    </transition>
  </v-card>
</template>

<script>
export default {
  name: 'profile',
  data () {
    return {
      active: null,
      tabs: [
        {
          title: 'Настройки',
          to: 'profile'
        },
        {
          title: 'Изменение пароля',
          to: 'change_password'
        }
      ]
    }
  }
}
</script>

<style scoped>
  .tab-link {
    color: rgba(0, 0, 0, 0.54);
    text-decoration: none;
  }
</style>
